export function reconcileFleetSelection(selected,authorized){
 const allowed=new Set(authorized);return [...new Set(selected)].filter(id=>allowed.has(id));
}
export function changeFleetSelection(selected,ids,checked,authorized){
 const next=new Set(reconcileFleetSelection(selected,authorized));
 for(const id of ids)if(authorized.includes(id)){if(checked)next.add(id);else next.delete(id);}
 return [...next];
}
